<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        อัปโหลดไฟล์
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการข้อมูลโทรศัพท์เคลื่อนที่
          </a>
        </li>
        <li class="active">อัปโหลดไฟล์</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header with-border">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <h3 class="box-title">อัปโหลดไฟล์รายการส่งเสริมการขาย</h3>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-sm-6">
                    <el-upload
                      type="file"
                      class="upload-demo"
                      ref="uploadInput"
                      action="#"
                      :on-change="onFileChange"
                      :file-list="fileList"
                      :auto-upload="false"
                      :limit="1"
                      :on-remove="removeFile"
                    >
                    <el-button
                      slot="trigger"
                      size="small"
                      type="primary"
                    >เลือกไฟล์ PDF</el-button>
                    <el-button
                      style="margin-left: 10px;"
                      size="small"
                      type="success"
                      :disabled="dis"
                      @click="submitUpload()"
                    >อัปโหลด</el-button>
                    </el-upload>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapMutations, mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      dis: true,
      fileList : [],
      fileType : null,
      formData : null
    };
  },
  computed: {
    ...mapState({
      monthly_regulate : store => store.Promotion.monthly
    })
  },
  created(){
    if(!this.monthly_regulate) this.$router.push({name : 'Manage_mobileOperator'})
  },
  methods: {
    ...mapMutations({
      UPDATE_ROW: "Promotion/UPDATE_ROW",
      SAVE_DATA: "Promotion/SAVE_DATA"
    }),
    ...mapActions({
      previewPromotions : "Promotion/previewPromotions"
    }),
    onFileChange(file) {
      let filedata = file.raw
      if (filedata.type === "application/pdf") {
        this.formData = null;
        this.formData = new FormData();
        this.formData.append("typeFile", "pdf");
        this.formData.append("file", filedata);
        this.fileType = "pdf"
        this.dis = false;
      } else {
        this.dis = true
        this.fileList = []
        this.MessageBox( "แจ้งเตือน", "กรุณาอัปโหลดเฉพาะไฟล์ PDF", "warning");
      }
    },
    removeFile(e){
      this.dis = true
    },
    submitUpload() {
      this.previewPromotions(this.formData)
      this.$router.push({ name: "Confirm_promotion_mobile" });
    }
  }
};
</script>
